import { buttonBaseThemes } from '../../components/ButtonBase/theme';
import { linkThemes } from '../../components/Link/theme';
import { menuItemThemes } from '../../components/MenuItem/theme';
import { modalThemes } from '../../components/Modal/theme';
import { paginationItemThemes } from '../../components/PaginationItem/theme';
import { popoverThemes } from '../../components/Popover/theme';
import { richTreeViewThemes } from '../../components/RichTreeView/theme';
import { tableCellThemes } from '../../components/TableCell/theme';
import { tableSortLabelThemes } from '../../components/TableSortLabel/theme';
import { textInputThemes } from '../../components/TextInput/theme';
import { tooltipThemes } from '../../components/Tooltip/theme';
import { treeItemThemes } from '../../components/TreeItem';
import { typographyThemes } from '../../components/Typography/theme';

import type { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-tree-view/themeAugmentation';

const componentsTheme: ThemeOptions['components'] = {
  ...buttonBaseThemes,
  ...linkThemes,
  ...menuItemThemes,
  ...modalThemes,
  ...paginationItemThemes,
  ...popoverThemes,
  ...richTreeViewThemes,
  ...tableCellThemes,
  ...tableSortLabelThemes,
  ...textInputThemes,
  ...tooltipThemes,
  ...typographyThemes,
  ...treeItemThemes,
};

export default componentsTheme;
